import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import { Hub, HubWithStatus } from "models/hub";
import { getHub, getHubs } from "store/services/Hubs/hubsThunks";

interface HubsState {
  hubs: HubWithStatus[] | null;
  hubsLoading: boolean;
  currentHub: HubWithStatus | null;
  hubLoading: boolean;
  error: string | null;
}

const initialState: HubsState = {
  hubs: null,
  hubsLoading: false,
  currentHub: null,
  hubLoading: false,
  error: null,
};

const hubsSlice = createSlice({
  name: "hubs",
  initialState,
  reducers: {
    setHubName: (state, action: PayloadAction<{ id: string; name: string }>) => {
      if (state.currentHub) state.currentHub.name = action.payload.name;
      if (state.hubs) {
        const hubIndex = state.hubs.findIndex((hub) => hub.id === action.payload.id);
        state.hubs[hubIndex] = { ...state.hubs[hubIndex], name: action.payload.name };
      }
    },
    setHubIsRestarting: (state, action: PayloadAction<{ id: string; value: boolean }>) => {
      if (state.currentHub) state.currentHub.isRestarting = action.payload.value;
      if (state.hubs) {
        const hubIndex = state.hubs.findIndex((hub) => hub.id === action.payload.id);
        state.hubs[hubIndex] = { ...state.hubs[hubIndex], isRestarting: action.payload.value };
      }
    },
    setCurrentHub: (state, action: PayloadAction<HubWithStatus>) => {
      state.currentHub = action.payload;
    },
    handleResetHubs: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      // Get all hubs states management
      .addCase(getHubs.pending, (state) => {
        state.hubsLoading = true;
        state.error = null;
      })
      .addCase(getHubs.fulfilled, (state, action: PayloadAction<HubWithStatus[]>) => {
        state.hubsLoading = false;
        state.hubs = action.payload;
      })
      .addCase(getHubs.rejected, (state, action) => {
        state.hubsLoading = false;
        state.error = action.error.message || "Failed to fetch Vision Cores";
      })

      // Get single hub states management
      .addCase(getHub.pending, (state) => {
        state.hubLoading = true;
        state.error = null;
      })
      .addCase(getHub.fulfilled, (state, action: PayloadAction<Hub>) => {
        state.hubLoading = false;
        if (state.hubs) {
          const hubIndex = state.hubs.findIndex((hub) => hub.id === action.payload.id);
          state.hubs[hubIndex] = { ...action.payload };
        }
      })
      .addCase(getHub.rejected, (state, action) => {
        state.hubLoading = false;
        state.error = action.error.message || "Failed to fetch Vision Cores";
      });
  },
});

export const { setHubName, setHubIsRestarting, setCurrentHub, handleResetHubs } = hubsSlice.actions;

export default hubsSlice;
